/* eslint-disable no-mixed-operators */
import {WixSdk} from 'js-sdk-wrapper';
import {areObjectsEqual} from '../utils/objects';
/**
 * @deprecated
 * @param settings
 * @param player
 * @param forceUpdate
 * @param widgetRectHeight
 * @param prevSettings
 */
export function setWidgetHeightOld({settings, prevSettings, player, forceUpdate, widgetRectHeight}) {
  // The old resize
  const playerHeight = player.offsetHeight;
  const topPart = player.querySelector('#top-part');
  const topPartHeight = topPart.offsetHeight;
  const tracklist = player.querySelector('#tracklist');
  const tracklistHeight = tracklist ? tracklist.offsetHeight : 0;
  // TODO: This really needs to be removed, it knows too much about internal dom structure
  const tracklistWrapper = player.querySelector('#tracklist-wrapper');
  const tracklistWrapperHeight = tracklistWrapper ? tracklistWrapper.offsetHeight : 0;
  const bordersHeight = playerHeight - topPartHeight - tracklistWrapperHeight;
  const firstTrack = player.querySelector('.track, .no-tracks');
  const firstTrackHeight = firstTrack && firstTrack.offsetHeight || 0;
  const bottomPadding = player.getBottomPadding ? player.getBottomPadding() : 0;
  const playerMinHeight = topPartHeight + firstTrackHeight + bordersHeight - bottomPadding;
  const playerMaxHeight = topPartHeight + tracklistHeight + bordersHeight - bottomPadding;

  // forceUpdate === true - force new widget height
  // forceUpdate === false - check that at least one track is visible and widgetRectHeight <= playerHeight
  if (forceUpdate) {
    if (tracklistHeight !== tracklistWrapperHeight || widgetRectHeight > playerMaxHeight) {
      WixSdk.setHeight(playerMaxHeight);
    }
    return;
  }

  if (areObjectsEqual(prevSettings, {})) {
    return;
  }

  if (widgetRectHeight > playerHeight) {
    WixSdk.setHeight(playerHeight);
    return;
  }

  if (
    areObjectsEqual(prevSettings.rect, settings.rect) &&
    areObjectsEqual(prevSettings.booleans, settings.booleans) &&
    areObjectsEqual(prevSettings.numbers, settings.numbers)
  ) {
    // no need to calculate height again
    return;
  }

  if (widgetRectHeight < playerMinHeight) {
    WixSdk.setHeight(playerMinHeight);
  }
}



// WEBPACK FOOTER //
// ./widget-player/deprecated.ts